export const extractOutput = (rawString) => {
    // 1. Remove ANSI escape codes
    const ansiRegex = /\x1B\[[0-?]*[ -/]*[@-~]/g;
    const noAnsi = rawString.replace(ansiRegex, '');

    // 2. Match 'output': '...' OR "output": "..."
    //    The `(["'])` captures either single or double quote and `\1` enforces matching same type
    const match = noAnsi.match(/['"]output['"]\s*:\s*(["'])([\s\S]*?)\1\s*\}/);

    if (!match) {
      throw new Error("Could not find 'output' in string");
    }

    // 3. Extract the captured value
    let output = match[2];

    // 4. Unescape common escaped sequences
    output = output
      .replace(/\\n/g, '\n')   // Newlines
      .replace(/\\"/g, '"')    // Escaped double quotes
      .replace(/\\'/g, "'");   // Escaped single quotes

    return output.trim();
  };